module.exports = __webpack_public_path__ + "media/images/lp/lp15_comment-e1ac849ec697e746e1453a35da00f258.webp";